import React from "react";

import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import { useHistory } from "react-router";
import { isElectronApp } from "../../helpers/Utils";

export default function ContextNavComponent(props) {
	const history = useHistory();

	const handleClick = (_, data = {}) => {
		if (data.back) {
			history.goBack();
		} else {
			history.goForward();
		}
	};

	const WRAPPER_TAG = true || isElectronApp() ? ContextMenuTrigger : "div";

	return (
		<>
			<ContextMenu id="market_context_menu">
				<MenuItem data={{ back: true }} onClick={handleClick}>
					Back
				</MenuItem>
				<MenuItem divider />
				<MenuItem onClick={handleClick}>Forward</MenuItem>
			</ContextMenu>

			<WRAPPER_TAG id="market_context_menu" style={{ height: "100%" }}>
				{props.children}
			</WRAPPER_TAG>
		</>
	);
}
